export default "__VITE_ASSET__e8b2d37d__"